module.exports = __webpack_public_path__ + "media/images/emblems/Boltigen-coat_of_arms-ec2d843f294e7b4c5ee209670b94d0c5.svg";